import { useEffect } from "react";
import { signal } from "@preact/signals-react";

export const isWindowFocused = signal(document.hasFocus());

const onFocus = () => (isWindowFocused.value = true);
const onBlur = () => (isWindowFocused.value = false);

// 즉시 실행되는 이벤트 리스너
window.addEventListener("focus", onFocus);
window.addEventListener("blur", onBlur);

// 컴포넌트는 cleanup만 담당
export function WindowFocusMonitor() {
  useEffect(() => {
    // cleanup 함수만 반환
    return () => {
      window.removeEventListener("focus", onFocus);
      window.removeEventListener("blur", onBlur);
    };
  }, []);

  return null;
}
